import React from "react";
import { useNavigate } from 'react-router-dom';
import Navbar from "./Navbar";
import Footer from "./Footer";

const PrivacyPolicy = () => {
  const navStyle = {
    backgroundColor: "#f0f0f0",
    padding: "12px 12px 12px 5%",
    borderRadius: "5px",
  };

  const ulStyle = {
    listStyleType: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    alignItems: "center",
    fontSize: "11px",
  };

  const liStyle = {
    marginRight: "6px",
  };

  const linkStyle = {
    textDecoration: "none",
    color: "#000",
    cursor:"pointer "
  };

  const pageStyle = {
    color:"rgb(93, 64, 55)",
    padding:"2% 5% 5% 5%",
    backgroundColor:"rgb(232, 240, 238)"
  };

  const headingStyle = {
    fontSize: "30px",
    margin:"0",
  };

  const paragraphStyle = {
    lineHeight: "1.8",
    textAlign: "justify",
  };

  const navigate = useNavigate();
    const Home = () => {
      navigate("/")
    }

  return (
    <>
    <Navbar />
    <section>
      <nav style={navStyle}>
        <ul style={ulStyle}>
          <li style={liStyle}>
            <a onClick={Home} style={linkStyle}>HOME</a>
          </li>
          <li style={liStyle}>&gt;</li>
          <li>
            <a style={linkStyle}>PRIVACY POLICY</a>
          </li>
        </ul>
      </nav>
    </section>
    <div className="qoffee-page" style={pageStyle}>
    <h1 style={headingStyle}>PRIVACY POLICY</h1>
    <br />

    <p style={paragraphStyle}>MagicRoast Qoffee Private Limited (the “Company”, “we”, “us” or “our”) values your privacy. This Privacy Policy (“Policy”) describes how we process personal information when you use the MagicRoast Qoffee website (“Website”).</p>

    <p style={paragraphStyle}>At MagicRoast Qoffee, accessible at www.magicroastqoffee.com, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by MagicRoast Qoffee and how we use it.</p>

    <p style={paragraphStyle}>This Privacy Policy applies to both our online and offline data collection practices, including the collection of Personal Data through various channels such as our websites, applications, third-party networks, Consumer Engagement Services, points of sale, and events. We may aggregate Personal Data collected from multiple sources, including but not limited to websites, offline events, and surveys.</p>

    <p style={paragraphStyle}>By accessing or using our website, you acknowledge that your personal information will be processed in accordance with this Policy. You expressly consent to the processing of the personal information you provide for the purposes set forth herein and as otherwise permitted by applicable laws. If you have any questions or require further information about our Privacy Policy, please contact us at connect@magicroastqoffee.com.</p>

    <br />

    <h2 style={headingStyle}>1. Consent:</h2>
    <p style={paragraphStyle}><strong>• Consent to Data Collection and Use</strong></p>
    <p style={paragraphStyle}>By accessing or using the Website and/or providing your information, you consent to the collection, use, and processing of your information in accordance with this Policy, including the sharing of your information as described herein.</p>

    <p style={paragraphStyle}><strong>• Policy Updates</strong></p>
    <p style={paragraphStyle}>We reserve the right to modify this Policy at any time. Any changes will be reflected on this page to ensure transparency regarding the information we collect, how we use it, and the circumstances under which it may be disclosed.</p>

    <h2 style={headingStyle}>2. Collection of Personally Identifiable Information and other Information:</h2>
    <p style={paragraphStyle}>The specific personal information we request from you, along with the purpose for which it is collected, will be clearly communicated at the time of collection. If you contact us directly, we may collect additional information, including but not limited to your name, email address, phone number, the content of your message and any attachments you provide, as well as any other information you choose to share. When you register for an account, we may request certain contact details, including but not limited to your name, company name, address, email address, and telephone number.</p>

    <br />

    <h2 style={headingStyle}>How we use your information:</h2>
    <p style={paragraphStyle}>✓ Provide, operate, and maintain our website<br />
      ✓ Improve, personalize, and expand our website<br />
      ✓ Understand and analyse how you use our website<br />
      ✓ Develop new products, services, features, and functionality<br />
      ✓ Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes<br />
      ✓ Send you emails<br />
      ✓ Find and prevent fraud.
    </p>

    <br />

    <h2 style={headingStyle}>3. Disclosure of Your Personal Data:</h2>
    <p style={paragraphStyle}>We do not share or transfer your personal information to any third party except as expressly stated in this Policy or with your explicit consent. However, to facilitate the delivery of ordered products, we may share necessary details, including your name, address, and contact number, with authorized third parties that assist in order fulfillment.</p>
    <p style={paragraphStyle}>These third parties may include, but are not limited to:</p>
    <p style={paragraphStyle}>1. Shipping Partners<br />2. Logistics Providers<br />3. Courier Services</p>
    <p style={paragraphStyle}>All such third parties are contractually obligated to maintain the confidentiality and security of your personal information and to use it solely for the purpose of providing the specified services.</p>

    <br />

    <h2 style={headingStyle}>4. Children's Information:</h2>
    <p style={paragraphStyle}>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>
    <p style={paragraphStyle}>Magic Roast Qoffee does not knowingly collect any Personal data from children under the age of 18. If we become aware that we have unintentionally collected personal data from a child under 18, we will promptly remove that information from our records. However, Magic Roast Qoffee may collect personal data from children under 18 directly from the parent or guardian, with the consent of that parent or guardian.</p>
    <p style={paragraphStyle}>If you think that your child provided information on our website which is irrelevant, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>

    <br />

    <h2 style={headingStyle}>5. Cookies and Web Beacons:</h2>
    <p style={paragraphStyle}>Like most websites, Magic Roast Qoffee uses cookies based on your consent. We determine the purposes for which these cookies are utilized. Cookies store information such as visitor preferences and pages accessed on our website, allowing us to optimize user experience by tailoring content based on browser type and other relevant data.</p>
    <p style={paragraphStyle}>Additionally, we collect information through log files, which automatically record website activity and track statistics related to your browsing behaviour.</p>
    <p style={paragraphStyle}>We also use web beacons (also known as "web bugs"), which are small snippets of code that display a graphic image on a webpage or in an email. These beacons collect data, such as your IP address and interaction details, including when an email was opened and which links were clicked.</p>
    <p style={paragraphStyle}>The information collected through web beacons is used for various purposes, including but not limited to:<br />
      • Tracking website traffic and analyzing user engagement<br />
      • Counting unique visitors<br />
      • Managing and auditing advertising campaigns<br />
      • Monitoring and optimizing email marketing performance<br />
      • Personalizing content to enhance user experience
    </p>
    <p style={paragraphStyle}>By using our website, you consent to our use of cookies, log files, and web beacons as described in this Policy. If you wish to manage or disable cookies, you may do so through your browser settings.</p>

    <br />

    <h2 style={headingStyle}>6. Disclosure, Storage, and Transfer of Personal Data:</h2>
    <p style={paragraphStyle}><strong>I. Confidentiality and Security</strong><br />We implement appropriate technical and organizational measures to ensure the confidentiality, integrity, and security of your personal data. However, these protections do not extend to information you choose to share in public areas, such as third-party social media platforms.</p>

    <p style={paragraphStyle}><strong>II. Access to Your Personal Data</strong><br />Only authorized personnel or agents who require access to fulfill specific business functions (e.g., customer support handling consumer records) will process your personal data on a need-to-know basis.</p>

    <p style={paragraphStyle}><strong>III. Security Measures:</strong><br />We store your personal data in secure environments to prevent unauthorized access, alteration, disclosure, or destruction. However, while we take reasonable measures to protect your data, no method of data transmission over the Internet is entirely secure, and we cannot guarantee absolute security during transmission.</p>

    <p style={paragraphStyle}><strong>IV. Your Responsibility:</strong><br />You play a vital role in protecting your personal data. We recommend:<br />a) Choosing a strong password and keeping it confidential.<br />b) Logging out of accounts when using shared or public devices.<br />c) Avoiding the storage of login credentials on public or unsecured devices.<br />d) Using privacy settings and controls where applicable.</p>

    <p style={paragraphStyle}><strong>V. Data Transfers:</strong><br />Given the international nature of our business, we may transfer your personal data within the Magic Roast Qoffee group or to third parties, as specified in Section 4, for the purposes described in this Policy. These transfers may occur to jurisdictions with different data protection laws than those applicable in your location. We ensure that appropriate safeguards, such as standard contractual clauses or equivalent legal mechanisms, are in place to protect your personal data during such transfers.</p>

    <br />

    <h2 style={headingStyle}>7. Retention of Personal Data:</h2>
    <p style={paragraphStyle}>We retain your personal data for as long as necessary to fulfill the purposes for which it was collected, comply with legal obligations, or as permitted under applicable laws. Data used to provide a personalized experience may be retained for a duration permitted by relevant legal and regulatory frameworks. Once the retention period expires, we securely delete or anonymize your personal data, unless further retention is required for legitimate business or legal purposes.</p>

    <br />

    <h2 style={headingStyle}>8. Links to Third-Party Websites:</h2>
    <p style={paragraphStyle}>Our website may contain links to third-party websites that are not governed by this Privacy Policy. These external sites may collect and process your personal data independently. We are not responsible for their privacy practices, content, or security. We encourage you to review the privacy policies of any third-party websites you visit before sharing your personal information.</p>

    <br />

    <h2 style={headingStyle}>9. Data Controllers & Contact Information:</h2>
    <p style={paragraphStyle}>If you have any questions, concerns, or complaints regarding this Privacy Policy, our data practices, or your privacy rights, please contact us at:<br />Email: connect@magicroastqoffee.com<br />We will acknowledge and investigate any concerns regarding our data processing practices, including potential violations of your rights under applicable privacy laws.</p>
  </div>
  <Footer />
  </>
  );
};

export default PrivacyPolicy;

